import React, { memo, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { Product } from "../../../services/productService";
import { selectProductHighlights } from "../selectors";

import { ProductInfoListItem } from "../../../components/attributeHandlers";

import { Bullet } from "./types";
import "./style.scss";

const ProductHighlights = () => {
  const [viewMoreHeight, setViewMoreHeight] = useState(0);
  const highlights = useSelector(selectProductHighlights);
  const productDetailsAttributesWrapperRef = useRef(null);
  const { t } = useTranslation("productDetails");

  const showDetailsAttributes = (list: Product["highlights"]["attributes"]) =>
    list.map((item, index) => {
      const values = item.values
        ? item.values?.map(val => val.label).join(", ")
        : "";

      return (
        <tr key={index}>
          <td>{item.label}</td>
          <td>{values}</td>
        </tr>
      );
    });

  useEffect(() => {
    let ulHeight = 0;

    const productTableDetails =
      productDetailsAttributesWrapperRef.current?.clientHeight;

    if (productTableDetails) {
      ulHeight = productDetailsAttributesWrapperRef.current.clientHeight;
    }
    if (viewMoreHeight !== ulHeight) {
      setViewMoreHeight(ulHeight);
    }
  }, [productDetailsAttributesWrapperRef.current]);

  const productAttributes = highlights?.attributes;
  const productBullets = highlights?.bullets?.values;

  return (
    <div className="product_quality_detail">
      {(productAttributes || productBullets) && (
        <>
          <div className="detail">
            <h2 id="detailInfo" className="selected_tab">
              {t("productDetail")}
            </h2>
            <h2 className="infoHeading">{t("shortDescription")}</h2>
            <div
              className="view_product_quality expand"
              style={{
                maxHeight: viewMoreHeight + 50
              }}
            >
              <ul
                className="product_quality_listing"
                ref={productDetailsAttributesWrapperRef}
              >
                {productBullets?.map((bullet: Bullet, index: number) => (
                  <ProductInfoListItem key={bullet.text + index} {...bullet} />
                ))}
                <li className="product_table_wrapper">
                  <table className="attribute_table">
                    <tbody>
                      {productAttributes &&
                        showDetailsAttributes(productAttributes)}
                    </tbody>
                  </table>
                </li>
              </ul>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default memo(ProductHighlights);
